export default function CategoryBadges({ categories = [], size = "sm" }) {
  if (!categories?.length) {
    return <span className="text-xs text-zinc-400 italic">Nessuna categoria</span>;
  }
  const base = size === "sm" ? "text-[10px] px-1.5 py-0.5" : "text-[11px] px-2 py-1";
  return (
    <div className="flex flex-wrap gap-1" data-testid="category-badges">
      {categories.map((c, i) => (
        <span
          key={c.category_id + "-" + i}
          data-testid={`cat-badge-${c.category_code}${c.is_primary ? "-primary" : "-additional"}`}
          className={`${base} uppercase tracking-wider rounded border font-medium ${
            c.is_primary
              ? "bg-black text-white border-black"
              : "bg-zinc-50 text-zinc-700 border-zinc-300"
          }`}
          title={c.is_primary ? "Categoria principale" : "Categoria aggiuntiva ammessa"}
        >
          {c.display_name}
          {!c.is_primary && <span className="ml-1 opacity-70">+</span>}
        </span>
      ))}
    </div>
  );
}
